var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96875 0.46875H1.09375C0.92799 0.46875 0.769019 0.534598 0.651808 0.651808C0.534598 0.769019 0.46875 0.92799 0.46875 1.09375V9.21875C0.46875 9.38451 0.534598 9.54348 0.651808 9.66069C0.769019 9.7779 0.92799 9.84375 1.09375 9.84375H2.96875C3.13451 9.84375 3.29348 9.7779 3.41069 9.66069C3.5279 9.54348 3.59375 9.38451 3.59375 9.21875V1.09375C3.59375 0.92799 3.5279 0.769019 3.41069 0.651808C3.29348 0.534598 3.13451 0.46875 2.96875 0.46875ZM9.21875 0.46875H7.34375C7.17799 0.46875 7.01902 0.534598 6.90181 0.651808C6.7846 0.769019 6.71875 0.92799 6.71875 1.09375V9.21875C6.71875 9.38451 6.7846 9.54348 6.90181 9.66069C7.01902 9.7779 7.17799 9.84375 7.34375 9.84375H9.21875C9.38451 9.84375 9.54348 9.7779 9.66069 9.66069C9.7779 9.54348 9.84375 9.38451 9.84375 9.21875V1.09375C9.84375 0.92799 9.7779 0.769019 9.66069 0.651808C9.54348 0.534598 9.38451 0.46875 9.21875 0.46875Z",
    stroke: "#262F5F",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.d377fbbf617144e601757a23ef9e7bd6.svg";
export { ForwardRef as ReactComponent };